import store from "../../../store";
export default (params) => {
  store.dispatch("change/show", {
    name: "rewardEquips",
    params,
  });
};
